module.exports = __webpack_public_path__ + "img/how-to-use-scanner-image.5325629d.png";